import version from '../../version.js';

let buildType = 0;

/// BUILD TYPE MUST NOT EXCEED 9. 0-9 are only supported values

switch(version.split('-').slice(1).join('-'))
{
	case '':
	case 'beta':
	case 'alpha':
		buildType = 0;
		break;
	default:
		buildType = 1;
		break;
	case 'static':
		buildType = 2;
		break;
	case 'develop':
		buildType = 9;
		break;
}

// force reporting as a develop build if loading as a module or with an invalid buildType
if(config.isModule || buildType >= 10)
{
	buildType = 9;
}

// version x.y.z-b      => xxxyyyzzzb
// version 0.8.1-beta   =>      80010
// version 1.20.0-bogus =>   10200001
const build = version.split('-')[0].split('.').reduce( (a,b) => 1000*a+1*b, 0 ) * 10 + (buildType);

export default function buildNumber(){ return build; }
